export default __webpack_public_path__ + "static/media/precious.63e594a2.png";